import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GlobalContextType {
  walletAddress: string;
  setWalletAddress: React.Dispatch<React.SetStateAction<string>>;
  avatarHash: string;
  setAvatarHash: React.Dispatch<React.SetStateAction<string>>;
  decks: string[];
  setDecks: React.Dispatch<React.SetStateAction<string[]>>;
  activeDeck: string;
  setActiveDeck: React.Dispatch<React.SetStateAction<string>>;
}

const GlobalContext = createContext<GlobalContextType | null>(null);

const GlobalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  
  const [walletAddress, setWalletAddress] = useState<string>('');
  const [avatarHash, setAvatarHash] = useState<string>('NO5aFIWD89H3Wv6bOIVYPlp5zYPpywb0mq5fdtlULYI');
  const [decks, setDecks] = useState<string[]>([ "WevaVJIMls-b7tU71XtocWCfcey3FWLZbJN-sUBYZeI"
   ]);
   const [activeDeck, setActiveDeck] = useState<string>("WevaVJIMls-b7tU71XtocWCfcey3FWLZbJN-sUBYZeI");
   const [winner, setWinner] = useState<string>('');

  return (
    <GlobalContext.Provider
      value={{
        walletAddress,
        setWalletAddress,
        avatarHash, 
        setAvatarHash,
        decks,
        setDecks,
        activeDeck,
        setActiveDeck,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};


export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};

export default GlobalProvider;
